import DataStore from "../DataStore";
import {makeEl} from "../../common/Utils";

export default class Info{
    private ds : DataStore;

    constructor(_wrapper: HTMLElement) {
        this.ds = DataStore.instance;
        this.templ(_wrapper);
    }

    /**
     * 카카오게임 체널링 관련 문구를 옵션으로 받지 않고 스테틱하게 처리하였다. 작업중인 현재 러브비트 한군데에서만 사용하고, 딱히 동적으로 만들 필요가 없기 때문.
     */
    templ(_parent: HTMLElement){
        if(this.ds.config.isKakaoGamesChannel){
            const infoEl = makeEl('div', _parent, {class: 'footer-info-kakaogameschannel'});

            infoEl.innerHTML = `
                <span>(주)카카오게임즈는 개별 디지털콘텐츠의 통신판매중개자로서 게임의 거래에 대한 의무와 책임은 각 제공자에게 있으며, <br>이와 관련하여 발생하는 문제에 대해서 당사는 법적 책임을 부담하지 않습니다.</span>
            `;
        }
    }

}
